/**
 * Demo data hooks.
 * This file exists to break circular dependencies between play-context.tsx and benchmark.selectors.ts
 */

import { useSelector } from 'react-redux';
import { createGlobalState } from 'react-use';
import { selectApp } from '@bbkAdminRedux/app/selectors';
import { FeatureFlagsE, useFeatureFlags } from '@bbkAdminUtils/feature-flags';
import { selectCurrentApp } from '@bbkAdminRedux/rtkq/current-user.slice';
import { useLocation } from '@bbkShared/react-router';
import { AuthorizedPaths } from '@bbkAdminRouter/router-paths';

export const useDisableDemoReports = createGlobalState<boolean>(false);

export const useShowDemoData = ({
  disableDemoReports = false,
}: { disableDemoReports?: boolean } = {}) => {
  const demoDataEnabled = useFeatureFlags(FeatureFlagsE.ENABLE_DEMO_REPORTS);
  const app = useSelector(selectApp);

  return (app?.show_demo_data || demoDataEnabled) && !disableDemoReports;
};

const NEW_PLAY_PATH_PATTERN = new RegExp(`${AuthorizedPaths.playNew}(/|$)`);
const UNIFIED_NEW_PLAY_PATH_PATTERN = new RegExp(
  `${AuthorizedPaths.unifiedPlaysNew}(/|$)`
);

export const useIsNewPlayPage = () => {
  const location = useLocation();
  return (
    NEW_PLAY_PATH_PATTERN.test(location.pathname) ||
    UNIFIED_NEW_PLAY_PATH_PATTERN.test(location.pathname)
  );
};

export const useShowPlayDemoData = ({
  disableDemoReports = false,
}: { disableDemoReports?: boolean } = {}) => {
  const app = useSelector(selectCurrentApp);
  const demoDataEnabled = useFeatureFlags(FeatureFlagsE.ENABLE_DEMO_REPORTS);
  const isNewPlayPage = useIsNewPlayPage();

  if (isNewPlayPage) {
    return false;
  }

  return (app?.show_play_demo_data || demoDataEnabled) && !disableDemoReports;
};
